import React from 'react';

import { useCustomTranslation } from '@/components/utils';
import City from '@/icons/small/City.svg';
import House from '@/icons/small/House.svg';
import Area from '@/icons/small/Pin.svg';
import District from '@/icons/small/Property-Multiple.svg';

import { HighlightedText } from './HighlightedText';
import type { CombinedSuggestion, LocationTypeCombined } from './SearchForm';
import {
  StyledDescription,
  StyledSuggestionIcon,
  StyledSuggestionItem,
  StyledType,
} from './SearchForm.styled';

interface ISuggestionItemProps {
  query: string;
  suggestion: CombinedSuggestion;
  isActive: boolean;
  handleSuggestionClick: () => void;
  handleSuggestionMouseEnter: () => void;
  handleSuggestionMouseLeave: () => void;
}

export const SuggestionItem = ({
  query,
  suggestion,
  isActive,
  handleSuggestionClick,
  handleSuggestionMouseEnter,
  handleSuggestionMouseLeave,
}: ISuggestionItemProps) => {
  const { t } = useCustomTranslation();
  const iconsMapping = (type: LocationTypeCombined) => {
    const placeTypes = {
      region: {
        icon: <Area />,
        name: t('searchHero.searchForm.placeType.administrative_area_level_1'),
      },
      country: {
        icon: <Area />,
        name: t('searchHero.searchForm.placeType.country'),
      },
      city: {
        icon: <City />,
        name: t('searchHero.searchForm.placeType.locality'),
      },
      place: {
        icon: <Area />,
        name: t('searchHero.searchForm.placeType.natural_feature'),
      },
      neighborhood: {
        icon: <District />,
        name: t('searchHero.searchForm.placeType.neighborhood'),
      },
      subLocality: {
        icon: <Area />,
        name: t('searchHero.searchForm.placeType.sublocality'),
      },
      postalCode: {
        icon: <District />,
        name: t('searchHero.searchForm.placeType.postal_code'),
      },
      displayId: {
        icon: <House />,
        name: suggestion.marketingTitle || 'Exposé',
      },
    };
    return {
      icon: placeTypes[type].icon ?? placeTypes?.place.icon,
      placeType: placeTypes[type]?.name ?? placeTypes?.place?.name,
    };
  };

  const { icon = '', placeType = '' } = iconsMapping(
    suggestion.type ?? 'place'
  );

  return (
    <StyledSuggestionItem
      onClick={handleSuggestionClick}
      onMouseEnter={handleSuggestionMouseEnter}
      onMouseLeave={handleSuggestionMouseLeave}
      $isActive={isActive}
    >
      <StyledSuggestionIcon>{suggestion.type && icon}</StyledSuggestionIcon>
      <StyledDescription>
        <div>
          <HighlightedText
            text={suggestion.description}
            highlightedText={query}
          />
        </div>
        {suggestion.type && <StyledType text={placeType} size="m" />}
      </StyledDescription>
    </StyledSuggestionItem>
  );
};
